import { OrderedColumnsT } from 'business/definitions';
import React, { useContext } from 'react';

type ContextType = {
    chartDimensions?: OrderedColumnsT;
    setChartDimensions: React.Dispatch<React.SetStateAction<OrderedColumnsT>>;
};

const initialContext: ContextType = {
    chartDimensions: undefined,
    setChartDimensions: () => {},
};
const ChartConceptionContext = React.createContext<ContextType>(initialContext);

export const useChartConceptionContext = () =>
    useContext(ChartConceptionContext);

export default ChartConceptionContext;
